import script from "./g-dynamic.vue?vue&type=script&lang=tsx"
export * from "./g-dynamic.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__